module.exports = __webpack_public_path__ + "img/energy.9be18d23.png";